import { useState } from "react";
import React from "react";
import {
  Col,
  Container,
  Row,
  FormGroup,
  Input,
  Button,
  Card,
  CardBody,
  CardTitle,
  Form,
  Label,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import SimpleBar from "simplebar-react";

import { Link } from "react-router-dom";

import avatar from "../../../assets/images/nav4.svg";
import byPass from "../../../assets/images/byPass.png";

import check from "../../../assets/images/check.svg";
import caldropdown from "../../../assets/images/cal-dropdown.svg";

import { Check } from "feather-icons-react/build/IconComponents";

const userData2 = [
  {
    name: "Glenn Holden",
    amount: "$490.51",
    byPass: "Gym/Club Name Here",

    status: "Paid",
    statusClass: "bg-soft-success ",
    permissions: "View Only",
    PaidOn: "11/10/24",
  },

  {
    name: "Lolita Hamill",
    amount: "$490.51",
    byPass: "Gym/Club Name Here",

    status: "Paid",
    statusClass: "bg-soft-success",
    permissions: "Full Access",
    PaidOn: "11/10/24",
  },
  {
    name: "Robert Mercer",
    amount: "$490.51",
    byPass: "Gym/Club Name Here",

    status: "Pending",
    statusClass: "bg-warning-subtle text-warning",
    permissions: "Manage users",
    permissions1: "Manage users",

    PaidOn: "11/10/24",
  },
  {
    name: "Marie Kim",
    amount: "$490.51",
    byPass: "Gym/Club Name Here",

    status: "Cancelled",
    statusClass: "bg-soft-danger ",
    permissions: "View Only",
    PaidOn: "11/10/24",
  },
  {
    name: "Sonya Henshaw",
    amount: "$490.51",
    byPass: "Gym/Club Name Here",

    status: "Paid",
    statusClass: "bg-soft-success",
    permissions: "Full Access",
    PaidOn: "11/10/24",
  },
  {
    name: "Marie Kim",
    amount: "$490.51",
    byPass: "Gym/Club Name Here",

    status: "Pending",
    statusClass: "bg-warning-subtle text-warning",
    permissions: "Manage gyms",
    PaidOn: "11/10/24",
  },
  {
    name: "Sonya Henshaw",
    amount: "$490.51",
    byPass: "Gym/Club Name Here",

    status: "Paid",
    statusClass: "bg-soft-success",
    permissions: "Full Access",
    PaidOn: "11/10/24",
  },
  {
    name: "Sonya Henshaw",
    amount: "$490.51",
    byPass: "Gym/Club Name Here",

    status: "Paid",
    statusClass: "bg-soft-success",
    permissions: "Full Access",
    PaidOn: "11/10/24",
  },
  {
    name: "Sonya Henshaw",
    amount: "$490.51",
    byPass: "Gym/Club Name Here",

    status: "Pending",
    statusClass: "bg-warning-subtle text-warning",
    permissions: "Manage users",
    PaidOn: "11/10/24",
  },
  {
    name: "Sonya Henshaw",
    amount: "$490.51",
    byPass: "Gym/Club Name Here",
    status: "Cancelled",
    statusClass: "bg-soft-danger",
    permissions: "Full Access",
    PaidOn: "11/10/24",
  },
];
const Payments = () => {
  document.title = "Payments | Elevated - Admin Dashboard";
  const [dropdownOpen, setDropdownOpen] = useState({
    dateRange: false,
    clubGym: false,
    paymentStatus: false,
  });

  const toggleDropdown = (dropdown) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [dropdown]: !prevState[dropdown],
    }));
  };
  return (
    <div>
      <Container fluid>
        <Row className="g-0">
          <Col>
            <Card className="rounded-4" style={{ height: "550px" }}>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex justify-content-start align-items-center">
                    <span className="font-size-16 fw-bold primary-black">
                      Payments
                    </span>
                    <span className="p-2 mx-3 filter-btn ff-sora font-size-16 fw-normal d-flex justify-content-between align-items-center">
                      <Input
                        type="text"
                        name="search"
                        className="hover-input bg-light ff-sora font-size-16 fw-normal rounded-3"
                        placeholder="Search"
                      />
                    </span>
                  </div>{" "}
                  <div className="d-flex justify-content-end align-items-center gap-2">
                    {/* Date Range Dropdown */}
                    <Dropdown
                      isOpen={dropdownOpen.dateRange}
                      toggle={() => toggleDropdown("dateRange")}
                    >
                      <DropdownToggle
                        caret
                        className="filter-btn d-flex ff-sora font-size-16 fw-normal justify-content-between align-items-center "
                      >
                        <span className="fw-bold">Date Range</span>
                        <img src={caldropdown} alt="Check" className="ms-2" />
                      </DropdownToggle>

                      <DropdownMenu>
                        <DropdownItem>Data</DropdownItem>
                        <DropdownItem>Range</DropdownItem>
                      </DropdownMenu>
                    </Dropdown>

                    {/* Club/Gym Dropdown */}
                    <Dropdown
                      isOpen={dropdownOpen.clubGym}
                      toggle={() => toggleDropdown("clubGym")}
                    >
                      <DropdownToggle
                        caret
                        className="filter-btn d-flex justify-content-between align-items-center "
                      >
                        <span className="fw-bold ff-sora font-size-16 ">
                          By Club/Gym
                        </span>
                        <img src={check} alt="Check" className="ms-2" />
                      </DropdownToggle>

                      <DropdownMenu>
                        <DropdownItem>Club</DropdownItem>
                        <DropdownItem>Gym</DropdownItem>
                      </DropdownMenu>
                    </Dropdown>

                    {/* Payment Status Dropdown */}
                    <Dropdown
                      isOpen={dropdownOpen.paymentStatus}
                      toggle={() => toggleDropdown("paymentStatus")}
                    >
                      <DropdownToggle
                        caret
                        className="filter-btn d-flex justify-content-between align-items-center "
                      >
                        <span className="fw-bold">Payment Status</span>
                        <img src={check} alt="Check" className="ms-2" />
                      </DropdownToggle>

                      <DropdownMenu>
                        <DropdownItem>Payment</DropdownItem>
                        <DropdownItem>Payment</DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>
                {/* <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mb-3">
                 
                  <div className="d-flex flex-row  justify-content-start align-items-center gap-2 w-100 mt-2 mt-sm-0 ">
                    <span className="font-size-16 fw-bold primary-black ff-sora mb-2 mb-sm-0">
                      Staff
                    </span>
                    <div
                      className="mx-sm-3 bg-light ff-sora d-flex justify-content-between align-items-center"
                      style={{ borderRadius: "12px", height: "48px" }}
                    >
                      <img
                        src={find}
                        alt="Background"
                        className="light-black"
                        style={{
                          height: "24px",
                          width: "24px",
                          marginLeft: "10px",
                        }}
                      />
                      <Input
                        type="text"
                        name="search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="ff-sora light-black font-size-14 fw-normal"
                        style={{ background: "transparent", border: "none" }}
                        placeholder="Search"
                      />
                    </div>
                  </div>

                
                  <div className="d-flex flex-row justify-content-end align-items-center gap-2 w-100 mt-2 mt-sm-0">
                    <Dropdown
                      isOpen={dropdownOpen.byRole}
                      toggle={() => toggleDropdown("byRole")}
                    >
                      <DropdownToggle
                        caret
                        className="filter-btn d-flex justify-content-between align-items-center"
                      >
                        <span>{selectedRole}</span>
                        <img src={check} alt="Location" className="ms-2" />
                      </DropdownToggle>
                      <DropdownMenu style={{ zIndex: 1 }}>
                        <DropdownItem onClick={handleClearFilters}>
                          Select Role
                        </DropdownItem>
                        {userRoles.map((role, index) => (
                          <DropdownItem
                            key={index}
                            value={role.id}
                            onClick={() => {
                              setSelectedRole(role.name);
                              setCurrentPage(1);
                              fetchStaff(1, searchTerm, role.name);
                            }}
                          >
                            {role.name}
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    </Dropdown>

                    <Link to="/add-staff">
                      <Button className="rounded-pill">Add New</Button>
                    </Link>
                  </div>
                </div> */}
                <SimpleBar style={{ height: "450px" }}>
                  <div
                    className="table-responsive  hide-scrollbar rounded-4"
                    style={{ height: "500px" }}
                  >
                    <Table className="table-borderless table-centered table-nowrap">
                      <thead>
                        <tr>
                          {/* <th>
                            <div className="form-check font-size-16">
                              <Input
                                type="checkbox"
                                className=" secondary-black"
                                id="customCheck1"
                                style={{
                                  borderColor: "black",
                                }}
                              />
                            </div>
                          </th> */}
                          <th>ID</th>
                          <th>User</th>
                          <th>Amount</th>
                          <th>By Pass For</th>
                          <th>Payment Status</th>

                          <th>Paid on</th>

                          <th></th>
                        </tr>
                      </thead>
                      <tbody style={{ minHeight: "550px" }}>
                        {userData2.map((user, index) => (
                          <tr key={index}>
                            {/* <td>
                              <div className="form-check font-size-16">
                                <Input
                                  type="checkbox"
                                  className=" secondary-black ff-sora font-size-16 fw-normal"
                                  id="customCheck1"
                                  style={{
                                    borderColor: "black",
                                  }}
                                />
                              </div>
                            </td> */}
                            <td className="font-size-14 mb-1 ff-sora fw-normal secondary-black">
                              {index + 1}
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <img
                                  src={avatar}
                                  className="avatar-xs rounded-2 object-fit-cover me-2"
                                  alt={`${user.name}'s avatar`}
                                />
                                <div>
                                  <h6 className="font-size-14 mb-1 ff-sora fw-normal secondary-black">
                                    {user.name}
                                  </h6>
                                </div>
                              </div>
                            </td>
                            <td className="font-size-14 mb-1 ff-sora fw-normal secondary-black">
                              {user.amount}
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <img
                                  src={byPass}
                                  className="avatar-xs rounded-2  ff-sora object-fit-cover me-2"
                                  alt={`${user.byPass}'s avatar`}
                                />
                                <div>
                                  <h6 className="font-size-14 mb-1 ff-sora fw-normal secondary-black">
                                    {user.byPass}
                                  </h6>
                                </div>
                              </div>
                            </td>
                            <td>
                              <span
                                className={`badge ${user.statusClass} font-size-14 py-2 ff-sora rounded-2 px-2`}
                              >
                                {user.status}
                              </span>
                            </td>

                            <td className="font-size-14 mb-1 ff-sora fw-normal secondary-black">
                              {user.PaidOn}
                            </td>

                            <td>
                              <span className="justify-content-center px-4 cursor-pointer">
                                &#x22EE;
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </SimpleBar>
              </CardBody>
            </Card>
            {/* <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "60px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
                backgroundColor: "#f5f5f5",
              }}
            >
              <div>
                <span className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                  {`Showing ${Math.min(
                    (currentPage - 1) * itemsPerPage + itemPerPage
                  )} of ${totalItems}`}
                </span>
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  style={{
                    width: "48px",
                    height: "48px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor: currentPage === 1 ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </Button>
                {[...Array(totalPages).keys()]
                  .slice(
                    Math.max(0, currentPage - 3),
                    Math.min(totalPages, currentPage + 2)
                  )
                  .map((page) => (
                    <Button
                      key={page + 1}
                      onClick={() => handlePageChange(page + 1)}
                      style={{
                        width: "48px",
                        height: "48px",
                        color: currentPage === page + 1 ? "white" : "#1f1f1f",
                        background:
                          currentPage === page + 1 ? "#3BABA6" : "#f5f5f5",
                        marginLeft: "10px",
                        marginRight: "10px",
                        borderRadius: "80px",
                        border: 0,
                      }}
                      className={currentPage === page + 1 ? "active" : ""}
                    >
                      {page + 1}
                    </Button>
                  ))}
                <Button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    width: "48px",
                    height: "48px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor:
                      currentPage === totalPages ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                >
                  &gt;
                </Button>
              </div>
            </div>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "60px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
              }}
            ></div> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Payments;
